import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import {DomainStore} from 'shared/store';
import {auth, endpoints, types} from 'main/tools';
import {TimeTrackingPayPeriod} from 'main/stores/time_tracking';
import moment from 'moment';

class MyTimesheetState {
  payPeriods = [];
  selectedPayPeriod;
  employeeId = _.get(auth, 'employee.id');
  store = new DomainStore();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.TIME_TRACKING.PAY_PERIODS.FOR_EMPLOYEE.with(this.employeeId),
    ]);

    this.payPeriods = _.orderBy(this.store._getAll(types.TIME_TRACKING.PAY_PERIOD).map(payPeriod => new TimeTrackingPayPeriod(payPeriod)), 'startDate', 'desc');

    if (_.isEmpty(this.payPeriods)) {
      window.location = '/time_tracking';
    } else {
      this.selectedPayPeriod = this.currentPayPeriod;
    }
  }

  selectPayPeriod(payPeriod) {
    this.selectedPayPeriod = payPeriod;
  }

  get sortedPayPeriods() {
    return _.orderBy(this.payPeriods, 'startDate', 'desc');
  }

  get currentPayPeriod() {
    return _.find(this.sortedPayPeriods, payPeriod => moment(payPeriod.startDate).isBefore(moment())) ||
      this.sortedPayPeriods[0];
  }
}

export default MyTimesheetState;
